import PopupWindow from "./PopupWindow.js";
import { toQuery, bytesToBase64 } from "./utils.js";

import {
  authorizationUrl,
  clientId,
  redirectUri,
  obcbasic,
  oauthServerUrl,
  scope,
  grant_type_ac,
  grant_type_rt,
  UserinfoUrl,
  corsmode,
  responseTypeCode,
  app_id,
  LogoutUrl,
  revokeTokenUrl,
  apikey,
  apikey_header,
  VlnState,
} from "./setting.js";

export const StorageKey = {
  auth_logInState: "auth.logInState",
  auth_AaccessToken: "auth.access_token",
  auth_IdToken: "auth.id_token",
  auth_TokenType: "auth.token_type",
  auth_ExpiresIn: "auth.expires_in",
  auth_RefreshToken: "auth.refresh_token",
  auth_RefrTnStHref: "RefrTnStHref",
  auth_VlnState: "auth.validationState",
  userInfo_sub: "userInfo.sub",
  userInfo_name: "userInfo.name",
  userInfo_app_id: "userInfo.app_id",
  userInfo_ett_group: "userInfo.entitlement_group",
  userInfo_email: "userInfo.email",
};

export const LogInState = {
  unauthorized: "unauthorized",
  authorized: "authorized",
  getToken: "getToken",
  setUserInfo: "setUserInfo",
};

export class DataService {
  // constructor(name, level) {
  //   this.name = name;
  //   this.level = level;
  // }

  static getDate = () => {
    const today = new Date();
    return today;
  };

  static async GetMemoryParams() {
    for (var key in StorageKey) {
      console.log(
        "key " +
          StorageKey[key] +
          " has value " +
          localStorage.getItem(StorageKey[key])
      );
    }
  }

  static async getAuthorizationHeader(value) {
    if (localStorage.getItem(StorageKey.auth_IdToken) !== "undefined") {
      if (this.isTokenExpired() === true) {
        console.log("token expired");
        await DataService.refreshToken();
      }
      value = "Bearer " + localStorage.getItem(StorageKey.auth_IdToken);
      return value;
    } else alert("TokenID missing");
  }

  static authorized(checkauth) {
    let LogInStatus = localStorage.getItem(StorageKey.auth_logInState);
    if (LogInStatus === LogInState.unauthorized) checkauth = false;
    else {
      checkauth = true;
    }
    return checkauth;
  }

  static getFetchHeader() {
    const headers = new Headers();
    headers.append(apikey_header, apikey);
    return headers;
  }

  static async fetchGet(url, headers) {
    return fetch(url, {
      method: "GET",
      mode: corsmode,
      headers: headers,
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => console.log("error:", error));
  }

  static async fetchPost(url, headers) {
    return fetch(url, {
      method: "POST",
      mode: corsmode,
      headers: headers,
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => console.log("error:", error));
  }

  static async refreshToken() {
    // aktuelle position merken
    localStorage.setItem(StorageKey.auth_RefrTnStHref, window.location.href);

    localStorage.removeItem(StorageKey.auth_logInState);
    DataService.getAuthCode();
  }

  static async refreshAccessToken() {
    const refresh_token = localStorage.getItem(StorageKey.auth_RefreshToken);

    let auth = bytesToBase64(new TextEncoder().encode(obcbasic));
    auth = "Basic " + auth;

    const headers = {
      Authorization: auth,
      // "Content-type": "application/x-www-form-urlencoded",
    };

    let queryParams = new URLSearchParams({
      grant_type: grant_type_rt,
      refresh_token: refresh_token,
    });

    const url = `${oauthServerUrl}?${queryParams}`;

    const token = await this.fetchPost(url, headers);

    // save session information
    localStorage.setItem(StorageKey.auth_AaccessToken, token.access_token);
    localStorage.setItem(StorageKey.auth_RefreshToken, token.refresh_token);
    localStorage.setItem(StorageKey.auth_TokenType, token.token_type);
    localStorage.setItem(StorageKey.auth_ExpiresIn, token.expires_in);
  }

  static async getToken() {
    // let auth_logInState = localStorage.getItem(StorageKey.auth_logInState);
    let auth_logInState = sessionStorage.getItem(StorageKey.auth_logInState);

    console.log("getToken status: " + auth_logInState);

    if (
      auth_logInState === LogInState.getToken &&
      window.location.href.indexOf("?code=") > -1
    ) {
      const query = window.location.search;
      let parameters = new URLSearchParams(query);
      let code = parameters.get("code");
      let state = parameters.get("state");
      // const value = window.location.search;
      // let code = value.substring(6, value.length);

      // Token validation
      if (state !== VlnState) {
        sessionStorage.setItem(
          StorageKey.auth_logInState,
          LogInState.unauthorized
        );
        localStorage.setItem(
          StorageKey.auth_logInState,
          LogInState.unauthorized
        );
        return;
      }

      localStorage.setItem(StorageKey.auth_VlnState, state);

      let auth = bytesToBase64(new TextEncoder().encode(obcbasic));
      auth = "Basic " + auth;

      const headers = {
        Authorization: auth,
        "Content-type": "application/x-www-form-urlencoded",
      };

      const queryParams = new URLSearchParams({
        grant_type: grant_type_ac,
        redirect_uri: redirectUri,
      });

      const url = `${oauthServerUrl}?${queryParams}&code=${code}`;

      const token = await this.fetchPost(url, headers);

      if (token) {
        // save session information
        localStorage.setItem(StorageKey.auth_AaccessToken, token.access_token);
        localStorage.setItem(StorageKey.auth_IdToken, token.id_token);
        localStorage.setItem(StorageKey.auth_TokenType, token.token_type);
        localStorage.setItem(StorageKey.auth_ExpiresIn, token.expires_in);
        localStorage.setItem(StorageKey.auth_RefreshToken, token.refresh_token);
      }

      sessionStorage.setItem(
        StorageKey.auth_logInState,
        LogInState.setUserInfo
      );
    }
  }

  static readTokenEntries() {
    const token = localStorage.getItem(StorageKey.auth_IdToken);
    if (token !== "undefined") {
      const arrayToken = token.split(".");
      let tokenPayload = JSON.parse(atob(arrayToken[1]));
      // tokenPayload = JSON.stringify(tokenPayload);
      console.log(tokenPayload);
      console.log("Token expires :" + new Date(tokenPayload.exp * 1000));
    } else {
      console.log("missing auth_IdToken");
    }
  }

  static isTokenExpired() {
    let token = localStorage.getItem(StorageKey.auth_IdToken);
    let arrayToken = token.split(".");
    let tokenPayload = JSON.parse(atob(arrayToken[1]));
    let checkvalue = parseInt(Date.now() / 1000) >= tokenPayload.exp;
    // alert("now: " + parseInt(Date.now() / 1000) + " exp: " + tokenPayload.exp);
    return checkvalue;
  }

  static refreshOnBackButton() {
    const navType = performance.getEntriesByType("navigation")[0].type;

    if (navType === "back_forward") {
      // page was loaded from history using back

      DataService.clearStorage();
      window.location.reload();
    }
  }

  static getAuthCode() {
    //  Event listener for Logout event to reload page
    window.addEventListener("storage", function (event) {
      if (event.key === "logout-event") {
        DataService.clearStorage();
        window.location.reload();
      }
    });

    window.addEventListener("pageshow", function (event) {
      var historyTraversal =
        event.persisted ||
        (typeof window.performance != "undefined" &&
          // window.performance.navigation.type === 2);
          performance.getEntriesByType("navigation")[0].type ===
            "back_forward");
      if (historyTraversal) {
        // Handle page restore.
        DataService.clearStorage();
        window.location.reload();
        return;
      }
    });

    // Test
    let check = sessionStorage.getItem("signForProd");
    if (
      check === "DoNotReload" &&
      window.location.host.substring(0, 3) === "www"
    ) {
      DataService.clearStorage();
      return;
    }
    // Test Ende

    this.refreshOnBackButton();

    let logIn_finished = localStorage.getItem(StorageKey.auth_logInState);
    if (logIn_finished) return;

    let auth_logInState = sessionStorage.getItem(StorageKey.auth_logInState);

    console.log("GetAuthcode: " + auth_logInState);

    if (!auth_logInState) {
      const responseTypeLocationKeys = {
        code: "search",
        token: "hash",
      };

      const width = 680;
      const height = 680;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2.5;
      const locationKey = responseTypeLocationKeys[responseTypeCode];

      var isCrossOrigin = false;

      const payload = {
        client_id: clientId,
        scope: scope,
        redirect_uri: redirectUri,
        response_type: responseTypeCode,
        state: VlnState,
      };
      const search = toQuery(payload);

      PopupWindow.open(
        // "_self",
        "_parent",
        `${authorizationUrl}?${search}`,
        {
          height,
          width,
          top,
          left,
        },
        {
          locationKey,
          isCrossOrigin,
        }
      );
      // localStorage.setItem(
      sessionStorage.setItem(StorageKey.auth_logInState, LogInState.getToken);
    }
  }

  static async getAuth() {
    DataService.refreshOnBackButton();

    let logIn_finished = localStorage.getItem(StorageKey.auth_logInState);
    if (logIn_finished) return;

    await this.getToken();
    await this.getUserInfo();
  }

  static async getUserInfo() {
    let auth_logInState = sessionStorage.getItem(StorageKey.auth_logInState);

    if (auth_logInState === LogInState.setUserInfo) {
      const access_token = localStorage.getItem(StorageKey.auth_AaccessToken);
      const headers = {
        accept: "application/json",
        Authorization: `Bearer ${access_token}`,
      };

      const url = `${UserinfoUrl}`;
      let userInfo = await this.fetchGet(url, headers);

      if (userInfo) {
        // save UserINfo
        localStorage.setItem(StorageKey.userInfo_sub, userInfo.sub);
        localStorage.setItem(StorageKey.userInfo_name, userInfo.name);
        localStorage.setItem(StorageKey.userInfo_app_id, userInfo.app_id);
        localStorage.setItem(
          StorageKey.userInfo_ett_group,
          userInfo.entitlement_group
        );
        localStorage.setItem(StorageKey.userInfo_email, userInfo.email);

        // check authorization
        if (userInfo.app_id && userInfo.entitlement_group) {
          if (
            userInfo.app_id !== app_id ||
            userInfo.entitlement_group.length < 1
          ) {
            localStorage.setItem(
              StorageKey.auth_logInState,
              LogInState.unauthorized
            );
          } else {
            localStorage.setItem(
              StorageKey.auth_logInState,
              LogInState.authorized
            );
          }
        } else {
          localStorage.setItem(
            StorageKey.auth_logInState,
            LogInState.unauthorized
          );
        }
      } else {
        localStorage.setItem(
          StorageKey.auth_logInState,
          LogInState.unauthorized
        );
      }

      sessionStorage.removeItem(StorageKey.auth_logInState);

      // remove search params & reload
      let urlObj = new URL(window.location.href);
      let redirectUri = localStorage.getItem(StorageKey.auth_RefrTnStHref);
      if (redirectUri) {
        localStorage.removeItem(StorageKey.auth_RefrTnStHref);
        urlObj = new URL(redirectUri);
      }
      urlObj.search = "";
      window.location.assign(urlObj.toString());
    }
  }

  static clearStorage() {
    window.localStorage.clear();
    window.sessionStorage.clear();
    localStorage.clear();
    sessionStorage.clear();

    // this.deleteAllCookies();
    this.revokeToken();
  }
  static logout() {
    // raise event for reload to similar tabs
    localStorage.setItem("logout-event", "logout" + Math.random());
    DataService.clearStorage();
    sessionStorage.setItem("signForProd", "DoNotReload");

    // window.location.href = `${LogoutUrl}?eraseCache=true`;
    window.location.href = `${LogoutUrl}`;
    // window.location.replace(`${LogoutUrl}`);
  }

  // static deleteAllCookies() {
  //   var cookies = document.cookie.split(";");

  //   for (var i = 0; i < cookies.length; i++) {
  //     var cookie = cookies[i];
  //     var eqPos = cookie.indexOf("=");
  //     var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
  //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  //   }
  // }

  static async revokeToken() {
    let id_token = localStorage.getItem(StorageKey.auth_IdToken);

    if (id_token) {
      let auth = bytesToBase64(new TextEncoder().encode(obcbasic));
      auth = "Basic " + auth;

      const headers = {
        Authorization: auth,
        "Content-type": "application/x-www-form-urlencoded",
      };

      const queryParams = new URLSearchParams({
        token: id_token,
      });

      const url = `${revokeTokenUrl}?${queryParams}`;

      // const revT = await this.fetchPost(url, headers);
      await this.fetchPost(url, headers);
    }
  }
  static getUserRoles(roles) {
    let value = localStorage.getItem(StorageKey.userInfo_ett_group);
    if (value) {
      const array = value.split(",");

      let i = 0;
      while (i < array.length) {
        array[i] = array[i].substring(5);
        i++;
      }

      roles = JSON.stringify(array);
    }
    return roles;
  }
}
